import {
  AccessControl,
  WarehouseLocationFeature,
} from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureEntitlements } from './featureEntitlements'
import { FeatureToggle } from './featureToggles'

export const shiftsAccessControl: DomainAccessControlConfig = [
  {
    permissions: Permission.ShiftsView,
    warehouseLocationFeatures: AccessControl.oneOf([
      WarehouseLocationFeature.RetailerPickup,
      WarehouseLocationFeature.RetailerAlcoholDelivery,
    ]),
  },
  {
    permissions: Permission.ShiftsView,
    featureEntitlementIds: [FeatureEntitlements.ScanAndPayRetailers],
  },
]

export const shiftsEditAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.ShiftsModify],
  },
]

export const csvHistoryAccessControl: DomainAccessControlConfig = {
  permissions: Permission.ShiftsModify,
  featureToggles: [FeatureToggle.bsmInIppEnable],
  warehouseFeatureToggles: [FeatureToggle.bsmInIppEnable],
}
